import { OrganizationProvider } from 'contexts';
import { useAppState } from 'contexts/AppContext';
import type { Patient } from 'fhir/r4';
import React from 'react';
import { useParams } from 'react-router-dom';
import { Loader, Message } from 'semantic-ui-react';
import useSWR from 'swr';

//import { ConnectSidebar } from 'components';

import Patient360 from '..';
import { AuthContextProvider } from '../../../contexts/AuthContext';
import FHIRFetcher from '../../../data/FHIRFetcher';


function PatientTab() {
  const { authState, appState } = useAppState();

  const { token, userEmail } = authState;
  const { gender, payers, practitionerId, practitionerName, vendors, foodCardVendors } = appState;

  // let hostName = window.location.hostname;
  const [loading, setLoading] = React.useState(true);
  // const authToken = localStorage.getItem(`${hostName}-authToken`);
  // const userEmail = localStorage.getItem(`${hostName}-userEmail`);
  // const gender = localStorage.getItem(`${hostName}-gender`);
  // const practitionerId = localStorage.getItem(`${hostName}-practitionerId`);
  // const practitionerName = localStorage.getItem(`${hostName}-practitionerName`);
  // const payers = JSON.parse(localStorage.getItem(`${hostName}-payers`));
  // const vendors = JSON.parse(localStorage.getItem(`${hostName}-vendors`));

  const _homeClicked = () => {
    window.open(`${window.location.host}/`, '_blank');
  };

  const options = {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
    revalidateIfStale: false,
    revalidateOnReconnect: false,
    onSuccess: (_data: unknown, _key: string, _config: unknown) => {
      setLoading(false);
    },
    onError: (err: Error, _key: string, _config: unknown) => {
      console.log(err);
      setLoading(false);
    },
  };

  const params = useParams();
  const patientId = params['patientId'];
  const _taskId = params['taskId'];

  /*
   * `FHIRFetcher<Patient>`, not bare `FHIRFetcher`: this is a `/Patient/{id}`
   * READ, which resolves to the resource itself rather than to a search
   * `Bundle` — so the fetcher's default `TResource` is the wrong one here.
   *
   * Instantiating it is also what gives SWR a `Data` to infer. At 0.5.7 a bare
   * generic function reference leaves `Data` unresolved, and `patientData`
   * came out as `{}`; `Patient360` then received `{}` where it dereferences a
   * `Patient`.
   */
  const {
    data: patientData,
    error: patientError,
    mutate: refreshPatientDetails,
    isValidating: isRefreshPatientDetailsLoading,
  } = useSWR([`/Patient/${patientId}`, authState.token], FHIRFetcher<Patient>, options);

  // NOTE: there's another AuthContextProvider in App.tsx, but this one is used to provide the auth context to the Patient component
  return (
    <AuthContextProvider
      // `AppContext` seeds these from `localStorage`, so `string | null`, while
      // `AuthContextType` declares `string`. Cast rather than defaulted: an `?? ''`
      // would send an empty bearer token to every downstream query instead of
      // failing loudly.
      value={{
        token: token as string,
        userEmail: userEmail as string,
        practitionerId: practitionerId as string,
        practitionerName: practitionerName as string,
        validateUSPSAddress: true,
        payers: payers,
        vendors: vendors,
        foodCardVendors: foodCardVendors ?? [],
        gender: gender as string,
      }}
    >
      <OrganizationProvider>
        {/* <ConnectSidebar> */}
          {loading && <Loader active inline="centered" />}
          <>
            {patientError && (
              <Message negative>
                <Message.Header>Oops!. Something went wrong.. </Message.Header>
                <p>{patientError.message}</p>
              </Message>
            )}
            {patientData && (
              <Patient360
                patient={patientData}
                refreshPatientDetails={refreshPatientDetails}
                isRefreshPatientDetailsLoading={isRefreshPatientDetailsLoading}
              />
            )}
          </>
        {/* </ConnectSidebar> */}
      </OrganizationProvider>
    </AuthContextProvider>
  );
}

export default PatientTab;
